<template>
  <generic-modal
    v-if="visible"
    @close="onClose"
    @submit="onSubmit"
    :disabled="!selectedLocationId"
    title="Locatie toevoegen"
  >
    <div class="tw-p-2">
      <div class="tw-mb-4">
        <div class="tw-font-medium tw-text-gray-700">Groep</div>
        <div class="tw-p-2 tw-border tw-border-gray-200 tw-rounded tw-bg-gray-50">
          {{ selectedGroupName || 'Laden...' }}
        </div>
      </div>

      <FormField
        label="Adressen"
        type="select"
        :options="locationOptions"
        v-model="selectedLocationId"
        :size="10"
      />

      <div v-if="locationOptions.length > 0" class="tw-my-2">
        Selecteer een adres om toe te voegen
      </div>
    </div>
  </generic-modal>
</template>

<script setup>
import { useQuery } from '@tanstack/vue-query'
import { computed, ref, watch } from 'vue'
import GenericModal from '@/components/shared/GenericModal.vue'
import FormField from '@/components/shared/FormField.vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  selectedGroupId: Number,
  locationOptions: Array,
})

const emit = defineEmits(['close', 'submit'])

const selectedLocationId = ref(null)
const selectedGroupId = computed(() => props.selectedGroupId)

const onClose = () => {
  selectedLocationId.value = null
  emit('close')
}

const onSubmit = () => {
  emit('submit', selectedLocationId.value)
  selectedLocationId.value = null
}

watch(
  () => props.locationOptions,
  (options) => {
    if (options && options.length === 1) {
      selectedLocationId.value = options[0].value
    }
  },
  { immediate: true }
)

// Fetch groups for location selection
const { data: groups } = useQuery({
  queryKey: ['groups'],
  queryFn: async () => {
    const response = await fetch('/groups/api/v1/group')
    return response.json()
  },
})

const selectedGroupName = computed(() => {
  return groups.value?.data?.find((g) => g.id === selectedGroupId.value)?.name
})
</script>
